export const GLOBAL_POSTER_ASPECT = 271 / 384;